export class AddLanguagesList {
  static type = '[Languages] AddLanguages';
}
